import { Grid } from '@mui/material';
import React, { Dispatch, SetStateAction } from 'react';
import filterIcon from '../../../assets/image/filter.png';

interface FilterButtonProps {
  isFilterIcon?: boolean;
  onClickFilter?: any;
}

function FilterButton({ isFilterIcon, onClickFilter }: FilterButtonProps) {
  const handleClickTuneIcon = () => {
    onClickFilter(true);
  };

  return (
    <Grid container style={{ position: 'relative' }}>
      {isFilterIcon ? (
        <Grid
          container
          alignItems={'center'}
          justifyContent='center'
          style={{
            borderRadius: '15px',
            border: '1px solid #dddddd',
            width: '40px',
            height: '40px',
            textAlign: 'center',
            position: 'absolute',
            top: '10px',
            right: '20px',
            zIndex: '99',
          }}
        >
          <img src={filterIcon} onClick={handleClickTuneIcon} alt='filterIcon' style={{ cursor: 'pointer' }} />
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  );
}

export default FilterButton;
